import styled from 'styled-components';
import { colors } from '../../const/color';
import LoadingProps from './types';

const LoadingStyled = styled.div<LoadingProps>`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.5);
  position: ${({ $fullScreen }) => ($fullScreen ? 'fixed' : 'absolute')};
  @keyframes loadingSpin {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
  &:after {
    width: 24px;
    height: 24px;
    border: 2px solid ${colors.primary};
    border-top-color: transparent;
    border-radius: 50%;
    position: absolute;
    top: ${({ $top }) => ($top ? $top : '50%')};
    left: ${({ $left }) => ($left ? $left : '50%')};
    content: '';
    margin: -14px 0 0 -14px;
    animation: loadingSpin 1s linear infinite;
  }
`;

export default LoadingStyled;
